module.exports = function (restangular, shopperService) {
    return {
        restrict: 'E',
        link($scope) {
            $scope.shopperService = shopperService;

            $scope.setAccessibilityPreference = function () {
                shopperService.setPreferenceEnableAccessibility(shopperService.preferences.EnableAccessibleOptions);
            };
        },
        template: require('./shopperaccessibility.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/auth/shopper/shopperaccessibility.directive.js